export default __webpack_public_path__ + "static/media/Offline_BG.7f19d3f3.png";